import { DashboardLayout } from "../../components/layout";


const Offers = () => {

    const breadcrumbs = [
        { label: "Seller", link: "/dashboard" },
        { label: "Orders" }
    ];
    return (
        <DashboardLayout className="relative" breadcrumbs={breadcrumbs}>
        </DashboardLayout>
    )
};

export default Offers;